import { render } from "./SingleApartment.vue?vue&type=template&id=5dc14e28&scoped=true"
import script from "./SingleApartment.vue?vue&type=script&lang=js"
export * from "./SingleApartment.vue?vue&type=script&lang=js"

import "./SingleApartment.vue?vue&type=style&index=0&id=5dc14e28&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5dc14e28"

export default script